import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, OnChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilesService } from '@services/files/files.service';
import { UserProfile } from '../../../dto/userProfile';
import { UserDto } from '../../../dto/userDto';
import { InvoiceDto } from '@dto/invoiceDto';
import { TransactionDto } from '@dto/transactionDto';
import { InvoicePDFType } from '@enums/invoicePDFType.enum';
import { ToastService } from '@services/toast/toast.service';
import { InvoicesService } from '@services/entity/invoices.service';
import { InvoiceSettingsDto } from '@dto/invoiceSettingsDto';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-invoice-pdf',
  templateUrl: './invoice-pdf.component.html',
  styleUrls: ['./invoice-pdf.component.scss']
})
export class InvoicePDFComponent implements OnInit, OnChanges {

  public type: number;
  public invoice: InvoiceDto;
  public ownerUserId: string;
  public owner: UserDto;
  public loading: boolean = true;
  public filename: string

  public currentPage = 1;
  public transactionsOfPage: Map<number, TransactionDto[]>;
  public pdfPageImages: Map<number, string>;

  public pageCount: number;

  public stationary: any;
  private canvasHeight: number;
  private canvasWidth: number;

  public invoiceSettings: InvoiceSettingsDto
  public profile: UserProfile;

  @Input('example') example: InvoiceDto
  @Input('exampleSettings') exampleSettings: InvoiceSettingsDto
  @Input('stationaryPreview') stationaryPreview: SafeUrl
  @ViewChild('pdf') pdf: ElementRef;

  constructor(
    private cdref: ChangeDetectorRef,
    public modal: NgbModal,
    public activeModal: NgbActiveModal,
    private filesService: FilesService,
    private invoicesService: InvoicesService,
    private toastService: ToastService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.example) {
        this.loading = false;
        this.invoice = this.example
      } else {
        this.loading = true;
        this.toastService.clear()
        this.toastService.loading($localize`:@@GeneratingPDFToast:PDF wird generiert ...`)
      }

      this.getInvoiceSettings()
    }, 0);

  }

  ngOnChanges() {
    this.calculatePages()
  }

  getInvoiceSettings() {
    this.invoicesService.getInvoiceSettingsOfUser(this.invoice.ownerUserId).subscribe(invoiceSettings => {
      this.invoiceSettings = invoiceSettings

      this.calculatePages()
      this.loadPictures()
    }, error => {
      console.error(error);
    })
  }

  loadPictures() {
    this.filesService.getPicture(`invoices/stationaries/${this.invoice.ownerUserId}.jpg`, false, "image/jpg").subscribe(result => {
      var unsafeImageUrl = URL.createObjectURL(result);
      this.stationary = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
      if (this.stationary && !this.example) {
        this.cdref.detectChanges()
        this.createCanvasData(this.currentPage)
      }
    }, error => {
      if (!this.example) {
        this.cdref.detectChanges()
        this.createCanvasData(this.currentPage)
      }
    })
  }

  calculatePages() {
    let transactionsPerPage = 0
    let transactions = null

    if (this.example) {
      transactionsPerPage = Math.floor((297 - this.exampleSettings.letterheadHeight - this.exampleSettings.footnoteHeight - 48) / 8)
      transactions = this.example.invoiceItems.slice(0, transactionsPerPage - 1)
      this.pageCount = 1;
    } else {
      transactionsPerPage = Math.floor((297 - this.invoiceSettings.letterheadHeight - this.invoiceSettings.footnoteHeight - 48) / 8)
      transactions = this.invoice.invoiceItems
      this.pageCount = Math.ceil(transactions.length / transactionsPerPage);
    }

    this.transactionsOfPage = new Map<number, TransactionDto[]>();
    this.pdfPageImages = new Map<number, string>();

    var page = 1;
    var counter = 0;
    var transactionsOfPage = [];

    transactions.forEach(transaction => {
      transactionsOfPage.push(transaction);
      counter++;

      if (counter >= transactionsPerPage) {
        this.transactionsOfPage.set(page, transactionsOfPage);
        page++;
        counter = 0;
        transactionsOfPage = [];
      }
    })

    this.transactionsOfPage.set(page, transactionsOfPage);
  }

  createPdf(canvasHeight: number, canvasWidth: number) {
    var pdf = new jsPDF('p', 'mm', 'a4', true);

    var fileWidth = pdf.internal.pageSize.getWidth();
    var fileHeight = pdf.internal.pageSize.getHeight();
    var heightLeft = fileHeight;

    var position = 0;
    pdf.addImage(this.pdfPageImages.get(1), 'PNG', 0, position, fileWidth, fileHeight);

    if (this.pageCount > 1) {
      for (var i = 2; i <= this.pageCount; i++) {
        position += heightLeft - fileHeight;
        pdf.addPage();
        pdf.addImage(this.pdfPageImages.get(i), 'PNG', 0, position, fileWidth, fileHeight);
      }
    }

    this.loading = false;

    if (this.type == InvoicePDFType.Download) {
      pdf.save(this.filename)
      this.modal.dismissAll()
      this.toastService.clear()
      this.toastService.success(`Rechnung erfolgreich heruntergeladen.`)
    } else if (this.type == InvoicePDFType.Email) {
      var blobPDF = new Blob([pdf.output('blob')], { type: 'application/pdf' })
      this.activeModal.close({ pdf: blobPDF })
      this.toastService.clear()
      this.toastService.success(`Rechnung erfolgreich verschickt.`)
    }
  }

  createCanvasData(page: number) {
    if (page > this.pageCount) {
      this.createPdf(this.canvasHeight, this.canvasWidth);
      return;
    }

    var data = document.getElementById('pdf');

    html2canvas(data, { scale: 2 }).then(canvas => {
      this.canvasHeight = canvas.height;
      this.canvasWidth = canvas.width;

      this.pdfPageImages.set(page, canvas.toDataURL('image/png'));

      this.currentPage++;
      this.cdref.detectChanges();

      this.createCanvasData(this.currentPage);
    });
  }
}
